module.exports = __webpack_public_path__ + "static/media/SA-516-Gr-60-465839-1086303.39c6729d.jpg";